var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Factory50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF360C",
    d: "M41.2,5h-7.3L32,43h11L41.2,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E64A19",
    d: "M33,23h-4v-6l-12,6v-6L5,23v20h28V23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M9 27H13V31H9zM17 27H21V31H17zM25 27H29V31H25zM9 35H13V39H9zM17 35H21V39H17zM25 35H29V39H25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Factory50);
export default __webpack_public_path__ + "static/media/icons8-factory-50.4b3002018dd0e36a4e11e776c13f9252.svg";
export { ForwardRef as ReactComponent };